export default {
    day: '2024-09-27',
    content: {
        meta: [
            {
                type: 'new',
                text: '300'
            },
            {
                type: 'new',
                text: '311'
            },
            {
                type: 'new',
                text: '312'
            },
            {
                type: 'bugfix',
                text: '310'
            },
            {
                type: 'accessibility',
                text: '313'
            },
            {
                type: 'anticheat',
                text: '317'
            },
            {
                type: 'anticheat',
                text: '318'
            },
            {
                unlock: 'gemFeature',
                type: 'appearance',
                text: '356'
            },
            {
                unlock: 'miningDepthDweller',
                type: 'clarity',
                text: '377'
            }
        ],
        mining: [
            {
                type: 'new',
                text: 'addedUpgrade',
                params: [8]
            },
            {
                unlock: 'miningDepthDweller',
                type: 'new',
                text: 'addedPrestigeUpgrade',
                params: [7]
            },
            {
                unlock: 'gemFeature',
                type: 'new',
                text: 'addedGemUpgrade',
                params: [2]
            },
            {
                unlock: 'miningPickaxeCrafting',
                type: 'new',
                text: 'addedOre',
                params: [2]
            },
            {
                unlock: 'miningDepthDweller',
                type: 'new',
                text: 'addedRareEarth',
                params: [1]
            },
            {
                unlock: 'miningDepthDweller',
                type: 'balance',
                text: '352'
            },
            {
                unlock: 'miningEnhancement',
                type: 'change',
                text: '309'
            },
            {
                unlock: 'miningGasSubfeature',
                type: 'qol',
                text: '348'
            }
        ],
        gem: [
            {
                type: 'new',
                text: '357'
            },
            {
                unlock: 'cardFeature',
                type: 'new',
                text: '358'
            },
            {
                unlock: 'eventFeature',
                type: 'new',
                text: '359'
            },
            {
                unlock: 'treasureFeature',
                type: 'new',
                text: '360'
            }
        ],
        village: [
            {
                unlock: 'villageLoot',
                type: 'balance',
                text: '355'
            },
            {
                unlock: 'villageOffering4',
                type: 'balance',
                text: '362'
            }
        ],
        achievement: [
            {
                type: 'balance',
                text: '328'
            },
            {
                type: 'balance',
                text: '329'
            },
            {
                type: 'balance',
                text: '347'
            }
        ],
        school: [
            {
                type: 'balance',
                text: '361'
            }
        ],
        card: [
            {
                type: 'context',
                text: '319'
            },
            {
                type: 'new',
                text: '314'
            },
            {
                type: 'new',
                text: '320'
            },
            {
                type: 'change',
                text: '321'
            },
            {
                type: 'balance',
                text: '322'
            },
            {
                type: 'balance',
                text: '323'
            }
        ],
        horde: [
            {
                type: 'new',
                text: 'addedAchievement',
                params: [1]
            },
            {
                type: 'new',
                text: 'addedUpgrade',
                params: [4]
            },
            {
                unlock: 'hordePrestige',
                type: 'new',
                text: 'addedPrestigeUpgrade',
                params: [4]
            },
            {
                unlock: 'hordeEquipment',
                type: 'new',
                text: 'addedHordeEquipment',
                params: [14]
            },
            {
                unlock: 'hordeBrickTower',
                type: 'new',
                text: 'addedHordeTower',
                params: [2]
            },
            {
                unlock: 'hordeHeirlooms',
                type: 'new',
                text: 'addedHordeHeirloom',
                params: [2]
            },
            {
                unlock: 'hordePrestige',
                type: 'new',
                text: 'addedHordeSigil',
                params: [2]
            },
            {
                unlock: 'hordePrestige',
                type: 'balance',
                text: '352'
            },
            {
                unlock: 'hordeEquipmentMastery',
                type: 'bugfix',
                text: '308'
            },
            {
                unlock: 'hordeEquipmentMastery',
                type: 'bugfix',
                text: '315'
            },
            {
                unlock: 'hordeBrickTower',
                type: 'qol',
                text: '342'
            },
            {
                unlock: 'hordeBrickTower',
                type: 'balance',
                text: '343'
            },
            {
                unlock: 'hordeBrickTower',
                type: 'balance',
                text: '344',
                balance: 'nerf',
                before: 'x1.1',
                after: 'x1.02'
            },
            {
                unlock: 'hordeEquipment',
                type: 'change',
                text: '345'
            },
            {
                unlock: 'hordeEquipment',
                type: 'balance',
                text: '346'
            },
            {
                unlock: 'hordeDamageTypes',
                type: 'balance',
                text: '369'
            },
            {
                unlock: 'hordeCorruptedFlesh',
                type: 'new',
                text: '370'
            },
            {
                unlock: 'hordeBrickTower',
                type: 'new',
                text: '371'
            },
            {
                unlock: 'hordeBrickTower',
                type: 'change',
                text: '376'
            },
            {
                unlock: 'hordeBrickTower',
                type: 'balance',
                text: '378',
                balance: 'nerf',
                before: '100%',
                after: '50%'
            },
            {
                unlock: 'hordeHeirlooms',
                type: 'balance',
                text: '382',
                balance: 'change',
                before: '+0.05x',
                after: '+0.25%'
            },
            {
                unlock: 'hordeEquipment',
                type: 'balance',
                text: '387'
            }
        ],
        farm: [
            {
                type: 'qol',
                text: '380'
            },
            {
                type: 'qol',
                text: '381'
            },
            {
                type: 'change',
                text: '325'
            },
            {
                type: 'change',
                text: '334'
            },
            {
                type: 'qol',
                text: '335'
            },
            {
                unlock: 'farmLuxuryCardPack',
                type: 'balance',
                text: '336',
                balance: 'buff',
                before: '5',
                after: '25'
            },
            {
                unlock: 'farmDisableEarlyGame',
                type: 'new',
                text: 'addedRareDrop',
                params: [1]
            },
            {
                unlock: 'farmCropExp',
                type: 'new',
                text: 'addedGene',
                params: [7]
            },
            {
                type: 'new',
                text: 'addedCrop',
                params: [5]
            },
            {
                unlock: 'farmFertilizer',
                type: 'new',
                text: 'addedFertilizer',
                params: [4]
            },
            {
                type: 'new',
                text: 'addedUpgrade',
                params: [7]
            },
            {
                unlock: 'farmDisableEarlyGame',
                type: 'clarity',
                text: '324'
            },
            {
                unlock: 'farmCropExp',
                type: 'context',
                text: '301'
            },
            {
                unlock: 'farmCropExp',
                type: 'new',
                text: '302'
            },
            {
                unlock: 'farmCropExp',
                type: 'balance',
                text: '337'
            },
            {
                unlock: 'farmCropExp',
                type: 'new',
                text: '338'
            },
            {
                unlock: 'farmCropExp',
                type: 'balance',
                text: '339'
            },
            {
                unlock: 'farmFertilizer',
                type: 'balance',
                text: '340'
            },
            {
                unlock: 'farmDisableEarlyGame',
                type: 'balance',
                text: '379'
            },
            {
                unlock: 'farmCropExp',
                type: 'balance',
                text: '341'
            },
            {
                unlock: 'farmFertilizer',
                type: 'balance',
                text: '365',
                balance: 'nerf',
                before: '10%',
                after: '4%'
            },
            {
                unlock: 'farmFertilizer',
                type: 'balance',
                text: '366'
            },
            {
                unlock: 'farmFertilizer',
                type: 'balance',
                text: '367'
            },
            {
                unlock: 'farmFertilizer',
                type: 'balance',
                text: '368',
                balance: 'nerf',
                before: '20%',
                after: '5%'
            },
            {
                unlock: 'farmAdvancedCardPack',
                type: 'balance',
                text: '383',
                balance: 'nerf',
                before: '+0.02%',
                after: '+0.01%'
            },
            {
                unlock: 'farmAdvancedCardPack',
                type: 'balance',
                text: '372',
                balance: 'change',
                before: '+1%',
                after: '+0.015x'
            },
            {
                unlock: 'farmCropExp',
                type: 'balance',
                text: '373'
            },
            {
                unlock: 'farmDisableEarlyGame',
                type: 'balance',
                text: '374'
            }
        ],
        event: [
            {
                unlock: 'farmFertilizer',
                type: 'balance',
                text: '333',
                balance: 'buff',
                before: '5',
                after: '20'
            },
            {
                unlock: 'nightHuntEvent',
                type: 'change',
                text: '384',
            },
            {
                unlock: 'nightHuntEvent',
                type: 'new',
                text: '385',
            },
            {
                unlock: 'nightHuntEvent',
                type: 'new',
                text: '386',
            },
        ],
        treasure: [
            {
                unlock: 'eventFeature',
                type: 'balance',
                text: '263',
                balance: 'nerf',
                before: '125%',
                after: '100%'
            },
            {
                unlock: 'eventFeature',
                type: 'balance',
                text: '331'
            },
            {
                unlock: 'eventFeature',
                type: 'balance',
                text: '332',
                balance: 'buff',
                before: '16',
                after: '32'
            },
            {
                unlock: 'miningSmoke',
                type: 'new',
                text: '353'
            },
            {
                type: 'qol',
                text: '354'
            }
        ],
        gallery: [
            {
                type: 'appearance',
                text: '304'
            },
            {
                type: 'new',
                text: 'addedAchievement',
                params: [4]
            },
            {
                type: 'new',
                text: 'addedGalleryIdea',
                params: [18]
            },
            {
                type: 'new',
                text: 'addedRelic',
                params: [15]
            },
            {
                type: 'new',
                text: 'addedUpgrade',
                params: [40]
            },
            {
                type: 'new',
                text: 'addedPrestigeUpgrade',
                params: [16]
            },
            {
                type: 'new',
                text: 'addedGemUpgrade',
                params: [5]
            },
            {
                unlock: 'galleryCanvas',
                type: 'new',
                text: '327'
            },
            {
                unlock: 'galleryInspiration',
                type: 'clarity',
                text: '306'
            },
            {
                type: 'context',
                text: '303'
            },
            {
                unlock: 'galleryConversion',
                type: 'change',
                text: '305'
            },
            {
                unlock: 'galleryConversion',
                type: 'new',
                text: '326'
            },
            {
                unlock: 'galleryShape',
                type: 'new',
                text: '307'
            },
            {
                unlock: 'galleryAuction',
                type: 'balance',
                text: '316'
            },
            {
                unlock: 'galleryAuction',
                type: 'balance',
                text: '363'
            },
            {
                unlock: 'galleryInspiration',
                type: 'balance',
                text: '364'
            },
            {
                unlock: 'galleryDrums',
                type: 'balance',
                text: '375'
            }
        ],
        cryolab: [
            {
                type: 'balance',
                text: '330',
                balance: 'nerf',
                before: '100%',
                after: '40%'
            },
        ],
        mining_1: [
            {
                type: 'balance',
                text: '349',
                balance: 'nerf',
                before: '2',
                after: '0.1'
            },
            {
                type: 'balance',
                text: '350',
                balance: 'buff',
                before: '25M',
                after: '2.5M'
            },
            {
                type: 'balance',
                text: '351',
                balance: 'nerf',
                before: 'x8',
                after: 'x7'
            }
        ],
        village_1: [
            {
                type: 'new',
                text: 'addedSubfeature'
            },
            {
                type: 'new',
                text: 'addedVillageRecipe',
                params: [30]
            },
            {
                type: 'new',
                text: 'addedUpgrade',
                params: [12]
            },
            {
                type: 'new',
                text: 'addedPrestigeUpgrade',
                params: [10]
            }
        ],
        horde_1: [
            {
                type: 'new',
                text: 'addedSubfeature'
            },
            {
                type: 'new',
                text: 'addedUpgrade',
                params: [11]
            },
            {
                type: 'new',
                text: 'addedPrestigeUpgrade',
                params: [11]
            },
            {
                type: 'new',
                text: 'addedHordeClass',
                params: [5]
            },
            {
                unlock: 'hordeAreaMonkeyJungle',
                type: 'new',
                text: 'addedTrinket',
                params: [19]
            }
        ],
    }
}
